import React, { FC } from 'react';
import { Stack } from '@mui/material';
import moment from 'moment';

import { ICreateAbsenceRequestDTO } from 'src/api/dtos';
import { SingleDatePicker } from 'src/shared/components';
import { API_DATE_FORMAT } from 'src/shared/constants';
import { useTranslate } from 'src/shared/providers';

type InputsType = Partial<Pick<ICreateAbsenceRequestDTO, 'startDate' | 'endDate'>>;

interface Props {
  inputs: InputsType;
  onUpdate: (inputs: InputsType) => void;
}

export const FullDaysAbsenceInputs: FC<Props> = ({ inputs, onUpdate }) => {
  const { t } = useTranslate();
  const { startDate, endDate } = inputs;

  const handleStartDateChange = (date: moment.Moment | null) => {
    const newEndDate =
      !endDate || moment(endDate).isBefore(date)
        ? date?.format(API_DATE_FORMAT)
        : moment(endDate).format(API_DATE_FORMAT);
    const newInputs: InputsType = { ...inputs, startDate: date?.format(API_DATE_FORMAT), endDate: newEndDate };

    onUpdate(newInputs);
  };

  const handleEndDateChange = (date: moment.Moment | null) => {
    const newInputs: InputsType = { ...inputs, endDate: date?.format(API_DATE_FORMAT) };

    onUpdate(newInputs);
  };

  return (
    <Stack direction="row" position="relative" justifyContent="flex-start" gap={1} marginBottom={2}>
      <Stack>
        <label className="small mb-2 fw-medium d-block required">{t('global.from')}</label>
        <SingleDatePicker
          id="startDate"
          value={startDate ? moment(startDate) : null}
          onChange={handleStartDateChange}
          placeholder={t('absences.selectDate')}
        />
      </Stack>
      <Stack>
        <label className="small mb-2 fw-medium d-block required">{t('global.to')}</label>
        <SingleDatePicker
          id="endDate"
          value={endDate ? moment(endDate) : null}
          onChange={handleEndDateChange}
          minDate={startDate ? moment(startDate) : undefined}
          placeholder={t('absences.selectDate')}
        />
      </Stack>
    </Stack>
  );
};
